export default {
    userCustomFields: state => state.userCustomFields,
    isAuthenticated: state => !!state.auth_greennCourse,
    currentAuth: state => state.auth_greennCourse || null,
    authStatus: state => state.status,
    authErrors: state => state.errors,
}